var cilShortText = ["512 512", "<rect width='256' height='32' x='128' y='192' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/><rect width='128' height='32' x='128' y='304' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/><path fill='var(--ci-primary-color, currentColor)' d='M48,432H464V88H48ZM80,120H432V400H80Z' class='ci-primary'/>"];

export { cilShortText };

